import moment from 'moment';
import { fetchUser } from '../../../api/users';
import { useState, useEffect } from 'react';

export const EscalationDetails = ({ escalationData, escalatedAt }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const getUser = async () => {
      const { user } = await fetchUser(escalationData.escalatedByUserId);
      if (!cancelled) {
        setUser(user);
      }
    };

    setUser(null);
    getUser();

    return () => {
      cancelled = true;
    };
  }, [escalationData.escalatedByUserId]);

  return (
    <div className='escalation-reason'>
      <p className='user'>
        {user?.name || 'Someone'} escalated this{' '}
        {moment(escalatedAt).fromNow()}
        :
      </p>
      <p className='reason'>{escalationData.reason}</p>
    </div>
  );
};
